module.exports = __webpack_public_path__ + "lb.svg?8da368bc7007a954d563479ae51cc1e9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/lb.svg
// module id = 1302
// module chunks = 27